import type { AccountKey } from "owa-client-types";
import { action } from "satcheljs";

export interface RefreshCachedItemBodiesForAccountsActionMessage {
    accountKeys: AccountKey[];
}

const refreshCachedItemBodiesForAccounts: (accountKeys: AccountKey[]) => RefreshCachedItemBodiesForAccountsActionMessage = action("REFRESH_CACHED_ITEM_BODIES_FOR_ACCOUNTS", accountKeys => ({
    accountKeys,
}));

export default refreshCachedItemBodiesForAccounts;
